import { ALLERGEN_NAMES, RECIPE_STATUS, STOCK_STATUS, PROD_STATUS } from "@/lib/format";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function AllergenBadge({ code, state, showName = false, className }) {
  const cls = state === "presente" ? "badge-red" : state === "tracce" ? "badge-amber" : "badge-grey";
  const label = state === "presente" ? "Presente" : state === "tracce" ? "Tracce" : "Assente";
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn("badge", cls, className)} data-testid={`allergen-badge-${code}`}>
          {code}{showName ? ` · ${ALLERGEN_NAMES[code]}` : ""}<span className="sr-only"> {label}</span>
          {state === "tracce" && <span className="ml-0.5 text-[10px] font-normal">tracce</span>}
        </span>
      </TooltipTrigger>
      <TooltipContent>{ALLERGEN_NAMES[code]} · {label}</TooltipContent>
    </Tooltip>
  );
}

export function AllergenList({ allergens = {}, max = 6, emptyText = "Nessun allergene" }) {
  const entries = Object.entries(allergens);
  if (!entries.length) return <span className="text-xs text-slate-500">{emptyText}</span>;
  const shown = entries.slice(0, max);
  return (
    <span className="flex flex-wrap gap-1">
      {shown.map(([c, s]) => <AllergenBadge key={c} code={c} state={s} />)}
      {entries.length > max && <span className="badge badge-grey">+{entries.length - max}</span>}
    </span>
  );
}

export function StatusBadge({ map, value, testId }) {
  const s = map[value] || { label: value, cls: "badge-grey" };
  return <span className={cn("badge", s.cls)} data-testid={testId}>{s.label}</span>;
}

export const RecipeStatusBadge = ({ value, testId }) => <StatusBadge map={RECIPE_STATUS} value={value} testId={testId || "recipe-status-badge"} />;
export const StockBadge = ({ value, testId }) => <StatusBadge map={STOCK_STATUS} value={value} testId={testId || "stock-status-badge"} />;
export const ProdStatusBadge = ({ value, testId }) => <StatusBadge map={PROD_STATUS} value={value} testId={testId || "prod-status-badge"} />;

export function FoodCostBadge({ value, target = 30 }) {
  if (value == null) return <span className="text-xs text-slate-500">—</span>;
  const cls = value > target ? "badge-red" : value > target - 5 ? "badge-amber" : "badge-green";
  return <span className={cn("badge tnum", cls)} data-testid="food-cost-badge">{value.toLocaleString("it-IT", { maximumFractionDigits: 1 })} %</span>;
}
